module.exports = __webpack_public_path__ + "static/media/HelpAI1_preview.17c094e9.jpg";